import {APP, SPOTS} from "../../constants";

const start = APP.defaultState;

export default function reducer(state = start, action) {

    const results = state.results;

    switch (action.type) {
        case SPOTS.ENTITY:
            return {...state, entity: {...start.entity, ...action.payload}};

        case SPOTS.CRUD:
            return {
                ...state,
                crud: {...start.crud, ...action.payload},
                entity: action.payload.entity,
                save: start.save,
            };

        case SPOTS.LIST:
            return {...state, results: {...state.results, loading: true}};

        case SPOTS.LIST_SUCCESS:
            return {...state, results: {...start.results, ...action.payload}, save: start.save, crud: start.crud};

        case SPOTS.LIST_FAILURE:
            return {...state, results: {...results, loading: false, error: action.payload}};

        case SPOTS.CREATE:
        case SPOTS.UPDATE:
        case SPOTS.DELETE:
            return {...state, save: {...start.save, loading: true}};

        case SPOTS.CREATE_SUCCESS:
        case SPOTS.UPDATE_SUCCESS:
        case SPOTS.DELETE_SUCCESS:
            return {...state, save: {...start.save, ...action.payload}};

        case SPOTS.CREATE_FAILURE:
        case SPOTS.UPDATE_FAILURE:
        case SPOTS.DELETE_FAILURE:
            return {...state, save: {...start.save, error: action.payload}};

        default:
            return state;
    }
}
